import request from "@/utils/http"; // 导入http中创建的axios实例

// 扫码出库预览
export function goodsSpecCount(data) {
  return request.post("/logisticsCodeOutStock/goodsSpecCount", data);
}

// 扫码出库提交
export function outStock(data) {
  return request.post("/logisticsCodeOutStock/outStock", data);
}

// 物流码校验
export function verify(seq) {
  return request.get(`/logisticsCodeOutStock/verify/${seq}`);
}

// 下级出库明细 代管
export function list_proxy(year,month) {
  return request.get(`/logisticsCodeOutStock/list/proxy/${year}/${month}`);
}

// 下级出库明细
export function list(year,month) {
  return request.get(`/logisticsCodeOutStock/list/${year}/${month}`);
}

// 销售报表
export function report(year,month) {
  return request.get(`/logisticsCodeOutStock/report/${year}/${month}`);
}

// 获取下级门店
export function child() {
  return request.get(`/merchant/child`);
}

// 进货金额
export function company_amount(year,month) {
  return request.get(`/logisticsCodeOutStock/list/company/amount/${year}/${month}`);
}

// 进货明细
export function company(year,month) {
  return request.get(`/logisticsCodeOutStock/list/company/${year}/${month}`);
}
